export default "__VITE_ASSET__BlTdA_hB__"